import { Controller } from "stimulus"

// Bugfix 32 (#1566): een oefeningkaart vertelt de rusttimer onderaan
// (rustbalk) welke rusttijd erbij hoort, zodra de sporter op de kaart tikt.
export default class extends Controller {
  static values = { seconden: Number }

  kies() {
    if (!(this.secondenValue > 0)) return
    window.dispatchEvent(new CustomEvent("ca:rusttijd", { detail: { seconden: this.secondenValue } }))
  }
}
